import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

export const CopilotAutoReschedulingCountExtendedProperty: ExtendedPropertyUri =
    getExtendedPropertyUri(
        '11000e07-b51b-40d6-af21-caa85edab1d0',
        'CopilotAutoReschedulingCount',
        'Integer'
    );
